import HelpPopover, { HelpPopoverProps } from 'components/molecules/HelpPopover';
import Button, { ButtonProps } from 'components/atoms/Button';

export interface ButtonWithHelpProps extends ButtonProps {
  helpText: string;
  helpClassName?: string;
  helpOptions?: Partial<HelpPopoverProps>;
}

function ButtonWithHelp({ helpText, helpClassName, helpOptions, ...rest }: ButtonWithHelpProps) {
  return (
    <HelpPopover {...(helpOptions || {})} content={helpText} flex className={helpClassName}>
      <Button type="primary" size="gloo-medium" {...rest} />
    </HelpPopover>
  );
}

export default ButtonWithHelp;
